module.exports = __webpack_public_path__ + "img/max-file-check--excel.9bfd50a3.svg";